import React, { useCallback, useEffect, useState } from 'react';
import DropDownButton from 'devextreme-react/drop-down-button';
import List from 'devextreme-react/list';
import { useAuth } from '../../contexts/auth';
import {getUserDetails} from '../../api/api'
import notify from 'devextreme/ui/notify';
import './UserPanel.scss';


export default function UserPanel({ menuMode }) {
  const { user, signOut, refreshSession } = useAuth();
  const [menuItems, setMenuItems] = useState([]);
  const [companyName, setCompanyName] = useState(null);

  const onUserDetailsSuccess = useCallback((data) => {
    if (data.company_name) {
      setCompanyName(data.company_name)
    }
  }, [setCompanyName])

  const onError = useCallback((error) => {
    if (error.status === 401) {
      refreshSession();
    } else {
      notify("An error has occured. Please try again later.", 'error', 2000);
      console.log(error);
    }
  }, [refreshSession]);

  useEffect(() => {
    if (user.signInUserSession) {
      let items = []
      items.push({
        text: user.signInUserSession.idToken.payload.email,
        icon: 'fas fa-user',
        disabled: true,
      })
      if (companyName === null) {
        getUserDetails(user, onUserDetailsSuccess, onError);
      } else {
        items.push({
          text: companyName,
          icon: 'fas fa-industry',
          disabled: true,
        })
      }
      items.push({
        text: 'Logout',
        icon: 'fas fa-sign-out-alt',
        onClick: signOut
      })
      setMenuItems(items)
    }
  }, [user, setMenuItems, signOut, companyName, onUserDetailsSuccess, onError]);

  const dropDownButtonAttributes = {
    class: 'user-button'
  };

  const buttonDropDownOptions = {
    width: 'auto'
  };

  return (
    <div className='user-panel'>
      {menuMode === 'context' && (

        <DropDownButton
            stylingMode='text'
            text={"Account"}
            showArrowIcon={false}
            elementAttr={dropDownButtonAttributes}
            dropDownOptions={buttonDropDownOptions}
            items={menuItems}
        >

        </DropDownButton>

      )}
      {menuMode === 'list' && (
        <List items={menuItems} />
      )}
    </div>
  );
}
